import { makeStyles, tokens, mergeClasses } from '@fluentui/react-components';
import type { PropsWithChildren, ReactNode } from 'react';

import { spacing } from '@/theme/tokens';

const useStyles = makeStyles({
  shell: {
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    gridTemplateColumns: '240px 1fr',
    gridTemplateAreas: '"header header" "nav main"',
    minHeight: '100dvh',
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
  },
  shellNarrow: {
    gridTemplateColumns: '64px 1fr',
  },
  header: {
    gridArea: 'header',
    borderBottomColor: tokens.colorNeutralStroke2,
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
    backgroundColor: tokens.colorNeutralBackground2,
  },
  nav: {
    gridArea: 'nav',
    borderRightColor: tokens.colorNeutralStroke2,
    borderRightStyle: 'solid',
    borderRightWidth: '1px',
    backgroundColor: tokens.colorNeutralBackground2,
    overflowY: 'auto',
  },
  main: {
    gridArea: 'main',
    padding: `${spacing.xxl} ${spacing.xxxl}`,
    overflowY: 'auto',
  },
});

interface AppShellProps {
  header: ReactNode;
  nav: ReactNode;
  narrow?: boolean;
}

export function AppShell({ header, nav, narrow, children }: PropsWithChildren<AppShellProps>) {
  const classes = useStyles();
  return (
    <div className={mergeClasses(classes.shell, narrow ? classes.shellNarrow : undefined)}>
      <header className={classes.header}>{header}</header>
      <nav className={classes.nav}>{nav}</nav>
      <main className={classes.main}>{children}</main>
    </div>
  );
}
